"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const qs_1 = __importDefault(require("qs"));
const API = {
    getListService: '/api/ac/v2/service/published/list',
    checkServiceClientId: '/api/ac/v2/service/published/check/clientId',
    getServiceDisplay: '/api/ac/v2/service/management/display/published/info',
    createService: '/api/ac/v2/service/published/create',
    updateDisplay: `/api/ac/v2/service/management/display/published/update`,
    updateLiveStatus: `/api/ac/v2/service/published/updateLiveStatus`,
    getListServiceInCompany: `/api/ac/v2/service/published/serviceInCompany`,
    updateKYCRequirement: '/api/console/service/config/kycrequirement',
    updateKYCApproveMode: '/api/console/service/config/approveMode',
    assignCompanyToService: '/api/console/service/config/company',
    changePlan: '/api/console/service/config/plan',
    requestEnterprise: '/api/console/service/config/requestEnterprise',
    updateServiceAccess: '/api/ac/v2/service/published/updateServiceAccess',
    allowBlockpassAccess: `/api/ac/v2/service/published/bpAccess/update`,
};
class ServiceManagementAPI {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    /**
     * Function to get list service
     * @param filter - filter by name or client_id. Eg: {name:'dev',client_id:'dev}
     * @param sort - field and order to sort. Eg: {name: 'asc',createdAt:'asc'}
     * @param page - page number
     * @param limit - limit number
     * @returns Return list service data
     */
    async getListService(filter = {}, sort, page = 0, limit = 10) {
        const query = {
            filter,
            sort,
            page,
            limit,
        };
        const url = `${API.getListService}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url, {});
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    /**
     * Function to check if service client id is valid
     * @param {string} clientId service client Id
     * @returns {Promise<boolean>}
     */
    async isValidServiceClientId(clientId) {
        const query = {
            clientId,
        };
        const url = `${API.checkServiceClientId}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url, {});
        return lodash_1.default.get(res, 'data.data.result.isValid', false);
    }
    /**
     * Function to create new service
     * @param {string} name service name
     * @param {string} clientId service client Id
     * @param {string} logo service logo link
     * @param {string} thumbnail service thumbnail link
     * @param {string} template service template
     * @param {boolean} isFirstService it is first service of merchant or not
     * @returns
     */
    async createService(name, clientId, logo, thumbnail, template, isFirstService) {
        const res = await this._httpClient.post(API.createService, {
            name,
            clientId,
            logo,
            thumbnail,
            template,
            isFirstService,
        });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    /**
     * API to get service display info
     * @param {string} clientId
     * @returns
     */
    async getServiceDisplay(serviceId) {
        const query = {
            serviceId: serviceId,
        };
        const url = `${API.getServiceDisplay}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url, {});
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                entities: {},
            };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    /**
     * API to update service display
     * @param {string} serviceId
     * @param {UpdateServiceDisplayPayload} updateParam
     * @returns
     */
    async updateDisplayInfo(serviceId, updateParam) {
        const data = {
            result: null,
            entities: {},
        };
        const query = { serviceId };
        const url = `${API.updateDisplay}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.put(url, updateParam);
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    /**
     * API to update service live status
     * @param {string} serviceId
     * @param {boolean} isLive
     * @returns
     */
    async updateLiveStatus(serviceId, isLive) {
        const data = {
            result: null,
            entities: {},
        };
        const query = {
            serviceId,
        };
        const url = `${API.updateLiveStatus}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.put(url, { isLive });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    /**
     * Function to get list service in company
     * @param companyId - id of company
     * @param page - page number
     * @param limit - limit number
     * @returns Return list service in company
     */
    async getListServiceInCompany(companyId, page = 0, limit = 10) {
        const query = {
            page,
            limit,
            companyId,
        };
        const url = `${API.getListServiceInCompany}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url, {});
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    /**
     * Function to update kyc requirement of service
     * @param clientId - client_id of service
     * @param serviceId - service Id
     * @param identityRequirements - list identity requirement
     * @param identityRequirementsCriteria - list identity requirement criteria (Age restriction, Country restrictions)
     * @param certificateRequirements - list certificate requirement
     * @returns
     */
    async updateKYCRequirement(clientId, serviceId, identityRequirements, identityRequirementsCriteria, certificateRequirements) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.put(API.updateKYCRequirement, {
            clientId,
            serviceId,
            identityRequirements,
            identityRequirementsCriteria,
            certificateRequirements,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    /**
     * Function to update kyc bot mode of service
     * @param clientId - client_id of service
     * @param serviceId - service Id
     * @param approveMode - kyc bot mode (none, basic, advanced)
     * @returns
     */
    async updateKYCApproveMode(clientId, approveMode, serviceId) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.put(API.updateKYCApproveMode, {
            clientId,
            approveMode,
            serviceId,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    /**
     * Function to assign company to service
     * @param clientId - client_id of service
     * @param serviceId - service Id
     * @param companyId - company Id
     * @returns
     */
    async assignCompanyToService(clientId, companyId, serviceId) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.post(API.assignCompanyToService, {
            clientId,
            companyId,
            serviceId,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    /**
     * Function to change plan of service
     * @param clientId - client_id of service
     * @param serviceId - service Id
     * @param companyId - company Id
     * @returns
     */
    async changePlan(clientId, billingPlanId, serviceId) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.post(API.changePlan, {
            clientId,
            billingPlanId,
            serviceId,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result || null;
        data.entities = resBody.entities || {};
        return data;
    }
    /**
     * Function to request enterprise plan
     * @param clientId - client_id of service
     * @param serviceId - service Id
     * @param kycRequirementNote - kyc requirement note
     * @returns
     */
    async requestEnterprise(clientId, serviceId, kycRequirementNote) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.post(API.requestEnterprise, {
            clientId,
            serviceId,
            kycRequirementNote,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result || null;
        data.entities = resBody.entities || {};
        return data;
    }
    /**
     * Function to update service access management
     * @param serviceId - service Id
     * @param status - service status
     * @param enableRegistration - flag to enable user register service or not
     * @param enableDashboard - flag to enable merchant use KYC dashboard or not
     * @param enableAPIKey - flag to enable API key feature or not
     * @returns
     */
    async updateServiceAccess(updateData) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.put(API.updateServiceAccess, updateData);
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    /**
     * API to update Blockpass's access in service
     * @param {string} serviceId
     * @param {boolean} allowBlockpassAccess
     * @returns
     */
    async allowBlockpassAccess(serviceId, allowBlockpassAccess) {
        const data = {
            result: null,
            entities: {},
        };
        const query = {
            serviceId,
        };
        const url = `${API.allowBlockpassAccess}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.put(url, { allowBlockpassAccess });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
}
exports.default = ServiceManagementAPI;
